// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-actions {
  overflow: visible;
}

/* Ensure buttons can shrink and do not force horizontal scroll */
.compact-actions .btn {
  min-width: 0;
  white-space: nowrap;
}

/* Smaller padding and font-size on very small screens to avoid wrapping/scrolling */
@media (max-width: 480px) {
  .compact-actions .btn {
    font-size: 0.68rem;
    padding: 0.2rem 0.35rem;
  }
}

/* Slightly larger but still compact on small screens */
@media (min-width: 481px) and (max-width: 767px) {
  .compact-actions .btn {
    font-size: 0.75rem;
    padding: 0.22rem 0.4rem;
  }
}

/* Desktop: keep normal small-button sizing */
@media (min-width: 768px) {
  .compact-actions .btn {
    font-size: 0.85rem;
    padding: 0.25rem 0.5rem;
  }
}

/* Fix popover display to prevent cutoff */
.popover {
  max-width: calc(100vw - 20px);
  overflow: visible !important;
  z-index: 1070 !important;
}

.popover-body {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 280px;
  font-size: 0.9rem;
  line-height: 1.4;
}

.popover-header {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Ensure popover doesn't overflow on mobile */
@media (max-width: 480px) {
  .popover {
    max-width: calc(100vw - 10px);
  }
  
  .popover-body {
    max-width: 200px;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ManageSubscription.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oFAAoF;AACpF;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".compact-actions {\r\n  overflow: visible;\r\n}\r\n\r\n/* Ensure buttons can shrink and do not force horizontal scroll */\r\n.compact-actions .btn {\r\n  min-width: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Smaller padding and font-size on very small screens to avoid wrapping/scrolling */\r\n@media (max-width: 480px) {\r\n  .compact-actions .btn {\r\n    font-size: 0.68rem;\r\n    padding: 0.2rem 0.35rem;\r\n  }\r\n}\r\n\r\n/* Slightly larger but still compact on small screens */\r\n@media (min-width: 481px) and (max-width: 767px) {\r\n  .compact-actions .btn {\r\n    font-size: 0.75rem;\r\n    padding: 0.22rem 0.4rem;\r\n  }\r\n}\r\n\r\n/* Desktop: keep normal small-button sizing */\r\n@media (min-width: 768px) {\r\n  .compact-actions .btn {\r\n    font-size: 0.85rem;\r\n    padding: 0.25rem 0.5rem;\r\n  }\r\n}\r\n\r\n/* Fix popover display to prevent cutoff */\r\n.popover {\r\n  max-width: calc(100vw - 20px);\r\n  overflow: visible !important;\r\n  z-index: 1070 !important;\r\n}\r\n\r\n.popover-body {\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  white-space: normal;\r\n  max-width: 280px;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.popover-header {\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n/* Ensure popover doesn't overflow on mobile */\r\n@media (max-width: 480px) {\r\n  .popover {\r\n    max-width: calc(100vw - 10px);\r\n  }\r\n  \r\n  .popover-body {\r\n    max-width: 200px;\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
